<div class="layout">
  <header class="layout-header">
    <div class="header-container">
      <!-- Left section: Brand -->
      <div class="header-brand clickable" (click)="navigateToDashboard()">
        <div class="brand-logo">
          <img src="assets/branding/logo.svg" alt="Printzell Logo" class="logo-image" />
        </div>
        <div class="brand-info">
          <!-- <div class="brand-title">printzell</div> -->
          <div class="brand-title">{{ 'app.title' | transloco }}</div>
        </div>
      </div>

      <!-- Right section: Actions and User -->
      <div class="header-actions">
        <!-- Admin Quick Link (for admin users only) -->
        <p-button
          *ngIf="currentUser?.role === 'admin'"
          icon="pi pi-users"
          [label]="'header.users' | transloco"
          styleClass="p-button-text p-button-sm header-action-btn"
          routerLink="/admin/users"
          [pTooltip]="'header.manageUsers' | transloco">
        </p-button>

        <!-- Language toggle -->
        <!-- <p-button
          [label]="currentLang === 'de' ? 'EN' : 'DE'"
          styleClass="p-button-text p-button-sm header-action-btn"
          (onClick)="toggleLanguage()"
          [pTooltip]="currentLang === 'de' ? ('header.switchToEnglish' | transloco) : ('header.switchToGerman' | transloco)">
        </p-button> -->

        <!-- Theme toggle -->
        <!-- <p-button
          [icon]="(themeService.isDarkMode$ | async) ? 'pi pi-sun' : 'pi pi-moon'"
          styleClass="p-button-text p-button-sm header-action-btn"
          (onClick)="toggleTheme()"
          [pTooltip]="(themeService.isDarkMode$ | async) ? ('header.switchToLightMode' | transloco) : ('header.switchToDarkMode' | transloco)">
        </p-button> -->

        <!-- Notifications badge -->
        <p-button
          icon="pi pi-bell"
          [badge]="notificationCount.toString()"
          badgeClass="p-badge-danger"
          styleClass="p-button-text p-button-sm header-action-btn"
          (onClick)="toggleNotifications()"
          [disabled]="notificationCount === 0">
        </p-button>

        <!-- User menu -->
        <div class="header-user-section" (click)="userMenu.toggle($event)">
          <p-avatar
            [label]="getUserInitials()"
            size="normal"
            [style]="{'background-color': getUserColor(), 'width': '28px', 'height': '28px', 'font-size': '12px'}">
          </p-avatar>
          <div class="user-info">
            <span class="user-name">{{ currentUser?.firstName }} {{ currentUser?.lastName }}</span>
            <small class="user-role">{{ getRoleDisplay(currentUser?.role) }}</small>
          </div>
          <i class="pi pi-chevron-down"></i>
        </div>

        <p-menu #userMenu [popup]="true" [model]="userMenuItems"></p-menu>
      </div>
    </div>
  </header>

  <main class="layout-content">
    <ng-content></ng-content>
  </main>

  <footer class="layout-footer">
    <div class="printzell-footer-brand">
      <div class="footer-logo-section">
        <div class="footer-brand-text">
          <div class="brand-name">printzell</div>
          <div class="brand-tagline">{{ 'footer.tagline' | transloco }}</div>
        </div>
      </div>
      <div class="footer-info">
        <span>© 2025 PRINTZELL</span>
        <span>|</span>
        <span>Version {{ appVersion }}</span>
        <!-- <span>|</span>
        <a href="#" class="footer-link">{{ 'footer.support' | transloco }}</a> -->
        <span>|</span>
        <a href="https://www.printzell.at" target="_blank" class="footer-link">www.printzell.at</a>
      </div>
    </div>
  </footer>
</div>
